import React, { useEffect, createElement } from 'react';
export function SEO() {
  useEffect(() => {
    // Inject JSON-LD Schema
    const scriptId = 'schema-json-ld';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [{
          '@type': 'LegalService',
          '@id': 'https://lapropertylaw.com.au/#legalservice',
          name: 'L.A Property Law & Conveyancing',
          url: 'https://lapropertylaw.com.au/',
          telephone: '+61 3 8617 2600',
          email: 'hello@lapropertylaw.com.au',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '202 Elgin Street',
            addressLocality: 'Carlton',
            addressRegion: 'VIC',
            postalCode: '3053',
            addressCountry: 'AU'
          },
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+61 3 8617 2600',
            contactType: 'customer service'
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '17:00'
          },
          areaServed: 'Victoria, Australia'
        }, {
          '@type': 'WebSite',
          '@id': 'https://lapropertylaw.com.au/#website',
          url: 'https://lapropertylaw.com.au/',
          name: 'L.A Property Law & Conveyancing'
        }, {
          '@type': 'WebPage',
          '@id': 'https://lapropertylaw.com.au/#webpage',
          url: 'https://lapropertylaw.com.au/',
          name: 'Property Lawyers & Conveyancing Carlton Melbourne | L.A Property Law',
          isPartOf: {
            '@id': 'https://lapropertylaw.com.au/#website'
          }
        }, {
          '@type': 'FAQPage',
          '@id': 'https://lapropertylaw.com.au/#faq',
          mainEntity: [{
            '@type': 'Question',
            name: 'When should I have a contract reviewed?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Before signing or bidding wherever possible. A review can identify conditions, disclosures and transaction risks that may affect your decision or require further advice.'
            }
          }, {
            '@type': 'Question',
            name: 'What is a Section 32 vendor statement?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'It is a disclosure document a Victorian seller provides to a buyer before the buyer signs the contract. It contains prescribed information about the property and should be considered together with the contract.'
            }
          }, {
            '@type': 'Question',
            name: 'Can you help with an auction purchase?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'The contract should ideally be reviewed before auction day because auction contracts are generally unconditional once the property is purchased. Send the contract and auction date with your enquiry.'
            }
          }, {
            '@type': 'Question',
            name: 'Can you assist with an SMSF or trust purchase?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'The existing practice information lists SMSF, family trust and unit trust property transactions. These matters commonly require coordination between the legal team, accountant, adviser and lender.'
            }
          }, {
            '@type': 'Question',
            name: 'How quickly can a contract be reviewed?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Timing depends on the document, transaction and current workload. Include your signing or auction deadline when submitting the contract so the team can assess urgency.'
            }
          }, {
            '@type': 'Question',
            name: 'Do I need a property lawyer or a conveyancer?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Both lawyers and licensed conveyancers can manage conveyancing work within their authorised scope. A property lawyer can also advise on broader legal issues when a transaction becomes more complex.'
            }
          }, {
            '@type': 'Question',
            name: 'How much does conveyancing cost in Victoria?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Fees depend on the property and the transaction, so we provide a confirmed fixed scope and fee in writing before any work begins. There is no cost to send a contract or request a quote, and no obligation to proceed.'
            }
          }, {
            '@type': 'Question',
            name: 'What is the cooling-off period when buying property in Victoria?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'For many private-sale residential purchases in Victoria there is a cooling-off period of three clear business days after signing the contract, with some exceptions, including auction purchases. Check your contract and obtain advice, because conditions and exceptions can apply to your situation.'
            }
          }, {
            '@type': 'Question',
            name: 'What checks happen before settlement?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Before settlement the team reviews the title and any encumbrances, confirms adjustments for rates and outgoings, prepares and verifies settlement figures, and coordinates the date and requirements with the other party. You are kept informed as the matter reaches completion.'
            }
          }, {
            '@type': 'Question',
            name: 'Do I need a lawyer for an off-the-plan purchase?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Off-the-plan contracts can be longer and more complex, with disclosure, sunset dates and variation clauses that benefit from legal review before you sign. Send the contract and any deadline with your enquiry.'
            }
          }]
        }]
      });
      document.head.appendChild(script);
    }
  }, []);
  return null;
}